import Dexie from "dexie";
import db from "../Db";

var DeleteTemporaire = Dexie.async(function* (ID) {
  yield db.open();
  yield db.TEMPORAIRE.delete(ID);
});

export default DeleteTemporaire;
